export default () => {
  if (process.client) {
    // 1. Создаем основной скрипт Метрики
    const scriptContent = `
      (function(m,e,t,r,i,k,a){
        m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)}
        m[i].l=1*new Date()
        for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return }}
        k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)
      })(window, document,'script','https://mc.yandex.ru/metrika/tag.js', 'ym')

      ym(25259228, 'init', {
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: true
      })
    `

    const scriptTag = document.createElement('script')
    scriptTag.type = 'text/javascript'
    scriptTag.innerHTML = scriptContent
    document.head.appendChild(scriptTag)

    const noscriptTag = document.createElement('noscript')
    noscriptTag.innerHTML = '<div><img src="https://mc.yandex.ru/watch/25259228" style="position:absolute; left:-9999px;" alt="" /></div>'
    document.head.appendChild(noscriptTag)
  }
}